exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-get-storage-tsx": () => import("./../../../src/pages/getStorage.tsx" /* webpackChunkName: "component---src-pages-get-storage-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-l-2-alias-tsx": () => import("./../../../src/pages/l2alias.tsx" /* webpackChunkName: "component---src-pages-l-2-alias-tsx" */)
}

